<template>
  <div id="app">
    <NavBar />
    <div class="container is-fluid">
      <div class="two columns">
        <div class="column is-2">
          <div class="section">
            <MainNavigation />
          </div>
        </div>
        <div class="column is-10">
          <div class="section">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import MainNavigation from '@/components/MainNavigation.vue'

export default {
    name: 'app',
    components: {
        NavBar,
        MainNavigation
    }
}
</script>

<style>
  .menu-label:not(:last-child) { margin-bottom: 0em !important; }
  .menu-list a { padding: 0.2em 0.75em !important; }
  .section { padding: 0.5rem 1.5rem !important; }
</style>
